import { Grid, Header, Loader, Segment } from "semantic-ui-react";
import QuoteItemsTable from "shared/forms/Quote/QuoteItemsTable";
import OrderInformation from "./OrderInformation";
import RecurringProducts from "./RecurringProducts";
import QuoteTotals from "../Quote/QuoteTotals";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import SubscriptionTotals from "pages/SubscriptionProducts/SubscriptionTotals";
import { useSelector } from "react-redux";
import { StringUtils } from "utils";
import { DateTimeUtils } from "dyl-components";
import NextInvoice from "./NextInvoice";

const OrderSummary = ({ quote, account_id, disabled, onPromptTaxCalculation, wereTaxesCalculated, finishTaxCalculation, canceled_order, shouldNotDisplayPriceChanges }) => {
    const { control } = useFormContext();

    const { field: cartField } = useController({
        name: "cart",
        control
    })

    const { fields: cart } = useFieldArray({
        control,
        name: "cart",
        keyName: "key",
    });

    const { field: orderStatusField } = useController({
        name: "order_status",
        control,
    });

    const isDeletingOrder = orderStatusField.value === "deleted";

    const isReadingProducts = useSelector(
        (state) => state.subscription.isReadingCurrentProducts
    );

    const nextInvoice = useSelector(state => Object.keys(state.order.order?.next_invoice || {}).length ? state.order.order?.next_invoice : state.subscription.next_invoice);
    const isReadingNextInvoice = useSelector(state => state.subscription.isReadingNextInvoice);
    const isDyl = useSelector(state => state.auth.dyl_employee);
    const { catalog_discounts = [] } = useSelector((state) => state.product_catalog);

    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Header color="primary">Order Information</Header>
                    <OrderInformation disabled={disabled} account_id={account_id} onPromptTaxCalculation={onPromptTaxCalculation} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column></Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Header color="primary">Order Summary</Header>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <QuoteItemsTable shouldNotDisplayPriceChanges={shouldNotDisplayPriceChanges} disabled={disabled || isDeletingOrder} quote={quote} cart={cart} isOrder canceled_order={canceled_order} onPromptTaxCalculation={onPromptTaxCalculation} catalog_discounts={catalog_discounts} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Header color="primary">Recurring Products</Header>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Segment loading={isReadingProducts} basic style={{ padding: 0 }}>
                        <RecurringProducts cart={cartField.value} />
                    </Segment>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} reversed='computer'>
                {disabled ? (!isReadingNextInvoice ? (
                    <>
                        {['monthly', 'quarterly', 'semi-annually', 'annually'].map(period => 
                            nextInvoice[period] && (
                                <Grid.Column key={period}>
                                    <Segment>
                                        <SubscriptionTotals
                                            subtotal={nextInvoice[period].subtotal || 0}
                                            total={nextInvoice[period].total || 0}
                                            totalDiscount={nextInvoice[period].discount || 0}
                                            totalFee={nextInvoice[period].fee || 0}
                                            totalTax={nextInvoice[period].tax || 0}
                                            label={!isDyl ? (period !== "semi-annually" ? StringUtils.capitalize(period) : "Semi-Annually") : nextInvoice[period].next_invoice_date ? DateTimeUtils.changeFormat(
                                                DateTimeUtils.convertUnixTimeToDate(nextInvoice[period].next_invoice_date),
                                                "",
                                                DateTimeUtils.WORD_DATE_FORMAT
                                            ) : ""}
                                        />
                                    </Segment>
                                </Grid.Column>
                            )
                        )}
                        {!canceled_order && (
                            <Grid.Column>
                                <Segment>
                                    <QuoteTotals shouldNotDisplayPriceChanges={shouldNotDisplayPriceChanges} isInvoice quote={quote} cart={cartField.value} />
                                </Segment>
                            </Grid.Column>
                        )}
                    </>
                ) : <Loader active inline='centered' /> ): (
                    <>
                        <Grid.Column>
                            <Segment>
                                <QuoteTotals isInvoice quote={quote} cart={cartField.value} disabled={disabled} account_id={account_id} wereTaxesCalculated={wereTaxesCalculated} finishTaxCalculation={finishTaxCalculation} />
                            </Segment>
                        </Grid.Column>
                        {isDyl && (
                            <NextInvoice 
                                quote={quote}
                                shouldNotDisplayPriceChanges={shouldNotDisplayPriceChanges}
                                cartItems={cartField.value}
                            />
                        )}
                    </>
                )}
            </Grid.Row>
        </Grid>
    );
};

export default OrderSummary;
